import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { DoNotDisturbOnOutlined, EditOutlined, MoreVertOutlined } from "@mui-symbols-material/w300"
import type { Row } from "@tanstack/react-table"
import type { ReactElement } from "react"
import React, { useRef, useState } from "react"

import type { Role } from "@/graphql/codegen/graphql"
import { SystemAdminDialog } from "@/screens/SystemAdmin/types"

interface RolesRowActionsProps {
  row: Row<Role>
  setSelectedRole: (role: Role) => void
  setDialogOpen: (open: SystemAdminDialog) => void
}

const RolesRowActions = ({ row, setSelectedRole, setDialogOpen }: RolesRowActionsProps): ReactElement => {
  const [open, setOpen] = useState<boolean>(false)
  const anchorElRef = useRef<HTMLButtonElement>(null)

  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  const handleClickEdit = () => {
    setSelectedRole(row.original)
    setDialogOpen(SystemAdminDialog.EDIT_ROLE)
    handleClose()
  }

  const handleDelete = () => {
    const role = row.original
    setSelectedRole(role)
    setDialogOpen(SystemAdminDialog.DELETE_ROLE)

    handleClose()
  }

  return (
    <>
      <IconButton aria-label='expand row' size='small' onClick={handleOpen} ref={anchorElRef}>
        <MoreVertOutlined />
      </IconButton>

      <Menu
        anchorEl={anchorElRef.current}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{
          paper: {
            className: "w-[200px] ",
          },
        }}
      >
        <MenuItem onClick={handleClickEdit} className={"cursor-pointer hover:bg-primary-100"}>
          <ListItemIcon>
            <EditOutlined />
          </ListItemIcon>
          <ListItemText primary='Edit' />
        </MenuItem>

        <MenuItem onClick={handleDelete} className={"cursor-pointer hover:bg-primary-100"}>
          <ListItemIcon>
            <DoNotDisturbOnOutlined />
          </ListItemIcon>
          <ListItemText primary='Delete' />
        </MenuItem>
      </Menu>
    </>
  )
}

export default RolesRowActions
